<label for="{{idInput}}" class="d-block font-size-14" *ngIf="style === 'link'">
    <span class="font-weight-bold pseudo-link">{{placeHolder}}</span>
    <span class="d-block text-muted" *ngIf="textFooter !== ''">{{textFooter}}</span>
</label>

<div class="pseudo-btn-file" title="{{title}}"
    [ngClass]="{'d-none': !(fileName==='' && inProgress===false && style === 'rectangle')}">
    {{placeHolder}}
    <input type="file" id="{{idInput}}" class="file-input-upload" title="{{title}}" name="" accept="{{fileType}}"
        (change)="onSelectFile($event)" />
</div>

<small *ngIf="fileName==='' && inProgress===false && style === 'rectangle'"
    class="form-text text-muted">{{textFooter}}</small>

<div class="file-upload-ctn no-border" [ngClass]="{'justify-content-center': style === 'link'}"
    *ngIf="fileName!=='' && inProgress===false">
    <div class="file-ctn">
        <div class="file-img-preview-wrap" *ngIf="isImage===true && urlImage !== ''">
            <img class="file-img-preview" src="{{urlImage}}" />
        </div>

        <div class="file-name-wrap like-pseudo-btn">
            <span>{{fileName}}&nbsp;</span>
            <button class="remove-file btn btn-sm mgn-left-6" type="button" title="Eliminar" (click)="removeFile()">
                <i class="pj-ico pj-ico-modal-error my-icon"></i>
            </button>
        </div>
    </div>
</div>

<div *ngIf="inProgress===true" class="form-control progress-bar progress-bar-striped progress-bar-animated"
    role="progressbar" attr.aria-valuenow="{{progressPercentaje}}" aria-valuemin="0" aria-valuemax="100"
    [ngStyle]="{width:progressPercentaje+'%'}">
    {{progressPercentaje}}%</div>